import trash from "../../../../assets/images/icons/trash-red.svg";
import { useEffect, useRef, useState } from "react";
import { zIndexs } from "../../../../interfaces/environment";
import { ControlledMenu } from "@szhsin/react-menu";
import { IsReadTypeEnum, NotificationType, NotificationTypes } from "../../../../interfaces/general";
import { del, getAll, put, responseValidator } from "../../../../scripts/api";
import API from "../../../../urls/api";
import { useAppSelector } from "../../../../redux/hooks";
import { DeviceEnum } from "../../../../redux/slices/environmentSlice";
import Button from "../../../../utils/component/button/button.index";
import { ButtonType } from "../../../../utils/component/button/button.interface";
import { getWebEnvConfig, isTouchScreen } from "../../../../scripts/helpers";
import useOnBlur from "../../../../scripts/hooks/useOnBlur";
import { useLocation } from "react-router-dom";
import { toast } from "mobin-toast";
import { toastMessages } from "../../../../scripts/toastMessages";
import { NotificationList } from "./NotificationList/notificationHeader.index";
import { Menu, MenuItem } from "@szhsin/react-menu";
import dots from "../../../../assets/images/icons/more.svg";
import { ReactComponent as SmsIcn } from "../../../../assets/images/icons/sms-notification.svg";
import notificationIcon from "../../../../assets/images/icons/Notification.svg";
import { shallowEqual } from "react-redux";
import Dialog from "../../../../utils/component/dialog/dialog.index";
import ConfirmationModal from "../../../../utils/component/confirmationModal/confirmationModal.index";
import NotificationComponent from "../../../../assets/images/component/NotificationSvg";

export default function Notifications(): JSX.Element {
    const { device } = useAppSelector(({ environment: { device } }) => ({ device }), shallowEqual);
    const [notifications, setNotifications] = useState<NotificationType[] | undefined>(undefined);
    const [filtredNotifications, setFiltredNotifications] = useState<NotificationType[] | undefined>(undefined);
    const [filters, setFilters] = useState<NotificationTypes[]>([]);
    const [unreads, setUnreads] = useState<NotificationType[]>([]);
    const [menuStatus, setMenuStatus] = useState(false);
    const [deleteDialogStatus, setDeleteDialogStatus] = useState(false);
    const ref = useRef<any>();
    const location = useLocation();
    const notificationMenuRef = useRef<any>();

    useOnBlur(notificationMenuRef, () => {
        if (notifications && device === DeviceEnum.desktop) {
            if (menuStatus && notifications.length > 0) {
                setMenuStatus(false);
            }
        }
    });

    useEffect(() => {
        setMenuStatus(false);
    }, [location]);

    useEffect(() => {
        getNotifications();
        const interval = setInterval(
            () => {
                getNotifications();
            },
            Number(getWebEnvConfig("notifTimer")) * 10000
        );
        return () => {
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        if (notifications) {
            setUnreads(notifications.filter((notif) => notif.is_read === IsReadTypeEnum.UNREAD));

            if (filters.length) {
                setFiltredNotifications(notifications.filter((notif) => filters.includes(notif.type)));
            } else {
                setFiltredNotifications(notifications);
            }
        }
    }, [notifications, filters]);

    const getNotifications = (update?: boolean) => {
        getAll((data, status) => {
            if (responseValidator(status)) {
                setNotifications(
                    data.result.map((item: NotificationType) => ({ ...item, is_read: item.is_read ? IsReadTypeEnum.READ : IsReadTypeEnum.UNREAD }))
                );
            }
        }, API.notification.list());
    };

    const handleReadAllNotifications = () => {
        if (notifications) {
            const unread = notifications.filter((item) => item.is_read === IsReadTypeEnum.UNREAD);
            if (unread.length > 0) {
                setNotifications((prev) =>
                    prev?.map((notif) => {
                        return {
                            ...notif,
                            is_read: IsReadTypeEnum.READ
                        };
                    })
                );
                put((data, status) => {}, API.notification.read(), { ids: unread.map((item) => item.id) });
            }
        }
    };

    const handleRemoveNotifications = () => {
        return new Promise((resolve) => {
            if (notifications) {
                del(
                    (data, status) => {
                        if (responseValidator(status)) {
                            toast({ title: toastMessages(38), type: "success" });
                            setNotifications([]);
                        }
                        resolve(true);
                        setDeleteDialogStatus(false);
                    },
                    API.notification.remove(),
                    { ids: notifications.map((item) => item.id) }
                );
            } else {
                resolve(true);
            }
        });
    };

    const handleOnNotificationDelete = (id: number) => {
        notificationMenuRef.current.focus();
        setNotifications((prev) => {
            if (prev) {
                return prev.filter((item) => item.id !== id);
            }
        });
    };

    const handleOnNotificationUpdate = (id: number, isRead: IsReadTypeEnum) => {
        notificationMenuRef.current.focus();
        setNotifications((prev) => {
            if (prev) {
                return prev.map((item) => {
                    if (item.id === id) {
                        if (isRead === IsReadTypeEnum.UNREAD) setUnreads([...unreads, { ...item, is_read: IsReadTypeEnum.UNREAD }]);
                        return {
                            ...item,
                            is_read: isRead
                        };
                    } else {
                        return item;
                    }
                });
            }
        });
    };

    return (
        <>
            <ConfirmationModal
                status={deleteDialogStatus}
                onClose={() => setDeleteDialogStatus(false)}
                onSubmit={handleRemoveNotifications}
                text="آیا می‌خواهید تمام اعلان‌ها را پاک کنید؟"
                modalType={"DELETE"}
                cancelButtonText="خیر"
                submitButtonText="بله"
            />
            <div ref={notificationMenuRef}>
                <div
                    ref={ref}
                    data-tip="اعلان‌ها"
                    onClick={() => setMenuStatus(!menuStatus)}
                    className={`relative ${!isTouchScreen() && "!bg-transparent"} bg-[#EFF0F6] rounded-lg size-[30px] flex items-center justify-center`}
                >
                    <NotificationComponent className={`${isTouchScreen() ? "!size-[25px]" : "!size-[30px]"}`} />
                    {unreads.length > 0 && (
                        <div
                            dir="ltr"
                            className="size-[18px] text-white text-[11px] flex items-center justify-center rounded-full bg-red-600 absolute top-0 right-0.5"
                        >
                            {unreads.length < 100 ? `${unreads.length}` : "+99"}
                        </div>
                    )}
                </div>
                {!isTouchScreen() ? (
                    <ControlledMenu
                        state={menuStatus ? "open" : "closed"}
                        menuClassName={`!bg-white !rounded-[16px] !top-[16px] p-0 !z-${zIndexs.otherModals}`}
                        arrow={true}
                        anchorRef={ref}
                        transition={true}
                        onClose={() => {
                            if (notifications?.length === 0) {
                                setMenuStatus(false);
                            }
                        }}
                    >
                        <div className="w-[490px] h-[500px] flex flex-col">
                            <div className="p-[14px] flex items-center gap-2 justify-between border-b border-secondary-500">
                                <span className="text-secondary-700 text-[13px] font-medium">اعلان‌ها</span>
                                {notifications && notifications.length > 0 && (
                                    <Menu
                                        menuClassName={`!w-[220px] absolute bg-white !p-0 overflow-hidden !rounded-[5px] !drop-shadow-2xl !shadow-none !select-none z-[1000000]`}
                                        menuButton={
                                            <img
                                                src={dots}
                                                alt="more"
                                                className="rotate-90 w-[18px] cursor-pointer shrink-0"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                }}
                                            />
                                        }
                                    >
                                        <div className="flex flex-col px-6">
                                            <MenuItem
                                                className="py-4 px-0 hover:bg-transparent flex items-center gap-2 cursor-pointer transition-all group border-b"
                                                onClick={handleReadAllNotifications}
                                            >
                                                <SmsIcn className="w-4 h-4" />
                                                <span className={`text-secondary-800 text-sm font-bold transition-all`}>خواندن همه</span>
                                            </MenuItem>
                                            <MenuItem
                                                className="py-4 px-0 hover:bg-transparent flex items-center gap-2 cursor-pointer transition-all group"
                                                onClick={() => setDeleteDialogStatus(true)}
                                            >
                                                <img className="w-4 h-4" src={trash} alt="trash" />
                                                <span className={`text-red-500 text-sm font-bold transition-all`}>حذف همه</span>
                                            </MenuItem>
                                        </div>
                                    </Menu>
                                )}
                            </div>
                            <NotificationList
                                filters={filters}
                                notifications={notifications}
                                onSelect={(filters) => setFilters(filters)}
                                onDelete={handleOnNotificationDelete}
                                onUpdate={handleOnNotificationUpdate}
                                onClick={() => getNotifications(true)}
                            />
                        </div>
                    </ControlledMenu>
                ) : (
                    <Dialog
                        status={menuStatus}
                        title="اعلان‌ها"
                        titleClssName="border-b border-secondary-500"
                        icon={notificationIcon}
                        onClose={() => setMenuStatus(false)}
                        closeOnBlur={true}
                    >
                        <div className="notification-dialog-height flex flex-col">
                            <NotificationList
                                filters={filters}
                                notifications={notifications}
                                onSelect={(filters: any) => setFilters(filters)}
                                onDelete={handleOnNotificationDelete}
                                onUpdate={handleOnNotificationUpdate}
                                onClick={() => getNotifications(true)}
                            />
                            {filtredNotifications && filtredNotifications.length > 0 && (
                                <div className="grid grid-cols-2 gap-4 px-8 pt-3 pb-2">
                                    <Button
                                        text="خواندن همه"
                                        autoFocus={false}
                                        className="text-sm !h-10"
                                        type={ButtonType.SECONDARY}
                                        onClick={handleReadAllNotifications}
                                    />
                                    <Button
                                        text="حذف همه"
                                        autoFocus={false}
                                        className="text-sm !h-10 bg-white !text-red-600 !border-red-600 hover:!bg-white"
                                        type={ButtonType.DELETE}
                                        onClick={() => setDeleteDialogStatus(true)}
                                    />
                                </div>
                            )}
                        </div>
                    </Dialog>
                )}
            </div>
        </>
    );
}
